import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getSearchingStreamItems } from '../../../api/search';

import { generateItemCIDKey } from '../../Items/utils/generateItemCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateChannelCIDKey } from '../../../utils/generateChannelCIDKey';

import { REQUEST } from '../../../constants/request';

export const fetchSearchingStreamItems = createAsyncThunk(
  'search/fetchSearchingStreamItems',
  async (itemData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getSearchingStreamItems(itemData, {
        cancelToken: source.token,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: ({ path }, { getState }) => {
      const state = getState();

      return state.search.items.request[path]?.loading !== REQUEST.pending;
    },
  },
);

export const fetchSearchingStreamItemsExtraReducers = {
  [fetchSearchingStreamItems.pending]: (state, action) => {
    checkAndSetLoadingWithId(
      state.items.request,
      action,
      generateChannelCIDKey(action.meta.arg.path),
    );
  },
  [fetchSearchingStreamItems.fulfilled]: (state, action) => {
    onMatchedRequest(
      state.items.request[generateChannelCIDKey(action.meta.arg.path)],
      action,
      () => {
        const byId = (action.payload.result.root?.children || [])?.reduce(
          (acc, item) => {
            const [, id] = item.id.split('::');

            const itemCIDKey = generateItemCIDKey({
              orgId: item.fields.orgId,
              streamId: item.fields.streamId,
              channelId: item.fields.channelId,
              streamItemId: id,
            });

            return {
              ...acc,
              [itemCIDKey]: item.fields,
            };
          },
          { ...state.items.byId },
        );

        state.items.byId = byId;
        state.items.allIds = Object.keys(byId);
      },
    );
  },
  [fetchSearchingStreamItems.rejected]: (state, action) => {
    handleRequestRejection(
      state.items.request[generateChannelCIDKey(action.meta.arg.path)],
      action,
    );
  },
};
